const Constant  = 
    {
         VYAPAR_ERP : 0,
         URID_CORPORATE : 1,
         URID_COMPANY : 2,
         URID_BRANCH : 3,
         URID_FRANCHISE : 4,
         URID_USER :20 ,
         DEFAULT_LANGUAGE_CODE : "en",
         LCJP_MERCHANT_TYPE:8,
    
         DEFAULTCLUSTERID : "0",
         SHEETLIMIT : "sheetlimit",
         MERCHANTDAILYEMAIL : "merchantdailyemail",
        
         POSTOKENMULTITIME : "postokenmultitime",
         EXPIRY : "expiry",
        
         CHANNELMPOS : "MPOS",
         CHANNELERP : "V2-ERP",
        
         SAAS_ADMIN:"saasadmin",
         SAAS_ADMIN_CONTACT:"saasadmincontact",
    
            //status
             STATUS_ACTIVE  : "active",
             STATUS_INACTIVE  : "inactive",
             STATUS_EXPIRED  : "expired",
             STATUS_BLOCK  : "block",
             STATUS_NEW  : "new",
             STATUS_DEACTIVE  : "deactive",
    
        // Settigns Constant
         SHOPIFY : "shopify",
         ALLOWDISCOUNT : "allowdiscount",
         SHOWPROFITASPERCOST : "SHOWPROFITASPERCOST",
         ALLOWPURCHASEMERGEITEM : "allowpurchasemergeitem",
         ALLOWNEGATIVESTOCK : "allownegativestock",
         MULTIBARCODE : "multibarcode",
         PRODUCTTYPE : "producttype",
         PRODUCTLEDGER : "productledger",
         RECIPESEARCHTYPE : "recipesearchtype",
         SELLRAWPRODUCTS : "sellrawproducts",
         SELLSEMIFINISHEDPRODUCTS : "sellsemifinishedproducts",
         SELLPACKAGINGPRODUCTS : "sellpackagingproducts",
         FINISHPRODUCTMAPPING : "finishproductmapping",
         MULTIDUPLICATEBARCODE : "multiduplicatebarcode",
         DEFAULTSALESQTYBLANK : "defaultsalesqtyblank",
         WEIGHTSCALE : "weightscale",
         WEIGHTSCALENO : "weightscaleno",
         SKIPWEIGHTSCALENO : "skipweightscaleno",
         WEIGHTSCALETYPE : "weightscaletype",
         WEIGHTSCALENOTOTAL : "weightscalenototal",
         ISTOUCH : "istouch",
         BATCHDISABLE : "batchdisable",
         BATCHCLOSED : "batchclosed",
         FATOORAHQRCODE : "fatoorahqrcode",
         SUSPENDPRODUCT : "suspendproduct",
         POSDESIGN : "posdesign",
         COMPANYOFFLINE : "companyoffline",
         ALLOWUPDATEPRICEINPOS : "allowupdatepriceinpos",
         GARMENTINDUSTRYTAXTYPE : "garmentindustrytaxtype",
         ALLOWSUPPLIERBILLSMS : "allowsupplierbillsms",
         ALLOWSUPPLIERBILLWHATSAPP : "allowsupplierbillwhatsapp",
         ALLOWSUPPLIERORDERWHATSAPP : "allowsupplierorderwhatsapp",
         ALLOWSUPPLIERBILLEMAIL : "allowsupplierbillemail",
         ALLOWSUPPLIERORDEREMAIL : "allowsupplierorderemail",
         ALLOWSUPPLIERWISEPRODUCTMAPPING : "allowsupplierwiseproductmapping",
         ALLOWCUSTOMERWISEPRODUCTMAPPING : "allowcustomerwiseproductmapping",
         MANAGEPOQUANTITYINPRODUCT : "managepoquantityinproduct",
         CUSTOMERCHECKCREDITLIMIT : "customercheckcreditlimit",
         SUPPLIERCHECKCREDITLIMIT : "suppliercheckcreditlimit",
         CUSTOMERCHECKCREDITLIMITDONOTALLOW : "customercheckcreditlimitdonotallow",
         SUPPLIERCHECKCREDITLIMITDONOTALLOW : "suppliercheckcreditlimitdonotallow",
         STOCKTRANSFERBRANCHMRPORPURCHASE : "stocktransferbranchmrporpurchase",
         STOCKTRANSFERFRANCHISEEMRPORPURCHASE : "stocktransferfranchiseemrporpurchase",
         MEMBERSHIP : "membership",
         FRANCHISENEWFLOW : "franchisenewflow",
         CASHMANAGERFLOW : "cashmanagerflow",
         REGISTERCASHWITHDRAWAL : "registercashwithdrawal",
         REGISTERWITHDRAWAL : "registerwithdrawal",
         STOCKVERIFICATIONOUTBYINVOICE : "stockverificationoutbyinvoice",
         ALLPRICESHOW : "allpriceshow",
         AUTOGENRATEBARCODE : "autogenratebarcode",
         ALLOWEINVOICE : "alloweinvoice",
         LASTSALESMRP : "lastsalesmrp",
         AMOUNT : "amount",
         PRODUCTCOSTLANDINGCOST : "productcostlandingcost",
         CUSTOMERTYPEWISECALCULATION : "customertypewisecalculation",
         ISWEIGHTSCALE : "isweightscale",
         VOICETHANKMSG : "voicethankmsg",
         VOICEMSG : "voicemsg",
         ALLOWUPIBUTTONINOLDPOS : "allowupibuttoninoldpos",
         ALLOWBIRTHDAYREMINDER : "allowbirthdayreminder",
         GSTVERIFYOPTION : "gstverifyoption",
         GARMENTTAX : "garmenttax",
         GARMENTTAX_CALCULATION_METHOD : "garmenttax_calculation_method",
         FOOTWEARTAX: "footweartax",
         PURCHASEALLOWFOCUSON: "purchaseallowfocuson",
    
         ADDNEWLINEINSALES : "addnewlineinsales",
    
         BARCODEGENRATESERIESWISE : "barcodegenrateserieswise",
         BARCODEMANAGE : "barcodemanage",
         BARCODEPREFIX : "barcodeprefix",
         BARCODESERIES : "barcodeseries",
         BARCODELENGTH : "barcodelength",
         NOTALLOWPRODUCTDELETEOFSTOCKAVAILABLE : "notallowproductdeleteofstockavailable",
         NOTALLOWCONTACTDELETEOFOUTSTANDINGAVAILABLE : "notallowcontactdeleteofoutstandingavailable",
         ALLOWATTACHMENTVALIDATION : "allowattachmentvalidation",
         TENDERMODEL : "tendermodel",
         BARCODESELLINGPRICE : "barcodesellingprice",
         BARCODEMANUFACTURINGDATE : "barcodemanufacturingdate",
         BARCODEEXPIRYDATE : "barcodeexpirydate",
         SALESWEBHOOK : "saleswebhook",
         LATESTBATCHSHOWINPOS : "latestbatchshowinpos",
    
        // ORDER MANAGEMENT
         PICKUP : "Pickup",
         NEW : "New",
         INPROGRESS : "In Progress",
         READY : "Ready",
         OUTFORDELIVERY : "OutForDelivery",
         REJECTED : "Rejected",
        
        // ORDER ONLINE STATUS
         ONLINE_ORDER_PENDING : "pending",
         ONLINE_ORDER_CONFIRMED : "Order confirmed",
         ONLINE_INPROGRESS : "In progress",
         ONLINE_OUTFORDELIVERY : "Out for delivery",
         ONLINE_DELIVERED : "Delivered",
         ONLINE_CANCELLED : "Cancelled",
    
         ONLINE_RETURNCANCELLED : "Return",
         OPEN_ORDER : "open",
         ORDER_DELIVER : "Order Delivered",
         ORDER_PARTIAL_RETURN : "Partial Return",
    
        
    
    
        // for gajanand
         ORDERCREATED : "ordercreated",
         ORDER_CLOSE : "orderclose",
         ORDER_REJECTED : "orderrejected",
    
         PRODUCT_TYPE_REGULAR : "regular",
         PRODUCT_TYPE_DISCOUNT : "discount",
         PRODUCT_TYPE_FREE : "free",
    
    ///	
    
         ALLOWINVOICESMS : "allowinvoicesms",
         ALLOWINVOICEWHATSAPP : "allowinvoicewhatsapp",
         ALLOWINVOICEEMAIL : "allowinvoiceemail",
    
         ALLOWPOSSMS : "allowpossms",
         ALLOWPOSWHATSAPP : "allowposwhatsapp",
         ALLOWPOSEMAIL : "allowposemail",
         ALLOWPOSPRINTING : "allowposprinting",
         ALLOWPOSMRPCHANGE : "allowposmrpchange",
         ALLOWPAYLATERPAYMENT : "allowpaylaterpayment",
         ALLOWOTPFORADVANCEPAYMENT : "allowotpforadvancepayment",
    
         ALLOWCUSTOMERBIRTHDAYSMS : "allowcustomerbirthdaysms",
         ALLOWSUPPLIERBIRTHDAYSMS : "allowsupplierbirthdaysms",
         ALLOWEMPLOYEEBIRTHDAYSMS : "allowemployeebirthdaysms",
         ALLOWPRINTINCASH : "allowprintincash",
         ALLOWPRINTINCARD : "allowprintincard",
         ALLOWPRINTINUPI : "allowprintinupi",
         ALLOWTENDERDMODELINCASHANDPRINT : "allowtenderdmodelincashandprint",
         REATILERMARGIN : "reatilermargin",
         WHOLESALERMARGIN : "wholesalermargin",
         SELLINGMARGIN : "sellingmargin",
         EWAYBILL : "ewaybill",
        //
    
        // ravi patel
         INSERT : 1,
         VIEW : 2,
         EDIT : 3,
         DELETE : 4,
         PDF_EXCEL_PRINT : 5,
         APPROVE_REJECT_ACTION : 6,
        // REJECT_ACTION : 7,
        //dEveSh
         FREE_QTY : 9,
         UNITCOST_MRP_SP_MARGIN_TAXTYPE : 10,
         DISCOUNT_1 : 11,
         DISCOUNT_2 : 12,
         FLAT_DISCOUNT : 13,
         ROUND_OFF : 14,
         ADDITIONAL_CHARGES_VALUE : 15,
         PRICE : 16,
         PURCHASE_PRICE_MRP : 17,
         SHOW_PROFIT : 18,
         QUANTITY : 19,
         ITEMCODE_PRODUCT : 20,
         CANCELED : 21,
         CLEARED : 22,
         UPLOAD_EXCEL : 23,
    
         CASH_FLOW_OWNER : "owner",
         CASH_FLOW_MANAGER : "manager",
    
         DASHBOARD_CUSTOMER_VIEW : "dashboardcustomerview",
         DASHBOARD_SUPPLIERS_VIEW : "dashboardsuppliersview",
         DASHBOARD_PRODUCT_VIEW : "dashboardproductview",
         DASHBOARD_TOTAL_STOCK_VIEW : "dashboardtotalstockview",
         DASHBOARD_CASH_IN_HAND_VIEW : "dashboardcashinhandview",
         DASHBOARD_BANK_ACCOUNT_VIEW : "dashboardbankaccountview",
         DASHBOARD_RECEIVABLE_OUTSTANDING_VIEW : "dashboardreceivableoutstandingview",
         DASHBOARD_PAYABLE_OUTSTANDING_VIEW : "dashboardpayableoutstandingview",
         DASHBOARD_SALES_INVOICE_VIEW : "dashboardsalesinvoiceview",
         DASHBOARD_SALES_POS_VIEW : "dashboardsalesposview",
         NAV_MENU_DASHBOARD : 1,
    
        // bhagyashree
         TALLY : "tally",
         CATEGORY : "category",
         BRAND : "brand",
         UOM : "uom",
         CONTACT_COMPANY : "company",
         CONTACT_BRANCH : "branch",
         DASHBOARD : "dashboard",
         PRODUCT : "product",
         CATEGORY_BRANDS : "category_brand",
         UNIT_OF_MEASUREMENT : "unitofmeasurement",
         STOCK : "stock",
         STOCKTRASFER : "stocktransfer",
         STOCKVERIFICATION : "stockverification",
         DISCOUNT : "discount",
         COUPON : "coupon",
         STOCKTRASFERREQUEST : "stocktransferrequest",
         OPENING_STOCK : "openingstock",
         EXPENSE : "expense",
         EXPENSES : "Expenses",
         EXPENSE_PAYMENT : "ExpensePayment",
         ACCOUNTS : "accounts",
         REPORTS : "reports",
         EMPLOYEE : "employee",
         USERROLE : "userrole",
         ORDERMANAGEMENT : "ordermanagement",
         KEY : "JaewHxKm46v82veyb3JaG9rxZnC6BZDqLXxzywNNj7BRqaPPK2rM5WZbF2tksM7bUYrhgYXzPcGRSY79qBEGjrGnG4dckxcpw2RWecJzFEFPNUsD9w45K9ETCWtqqLgE",
         CREATE : "create",
        //  VIEW:"view",
         ISDELETE : "delete",
        //  EDIT:"edit",
         EXCEL : "excel",
         PDF : "pdf",
         MAIL : "mail",
         MATERIALCONSUMPTION : "materialconsumption",
    
         ADDITIONAL_CHARGE : "additional_charge",
    
         ACCOUNT_CONTACT : "contact",
         ACCOUNT_CUSTOM : "account_custom",
         ACCOUNT_JOURNAL : "JOURNAL_VOUCHER",
    
         ACCOUNTING_CREDIT_NOTEL : "JOURNAL_VOUCHER",
         ACCOUNTING_DEBIT_NOTE : "debit_note_accounting",
         ACCOUNTING_CREDIT_NOTE : "credit_note_accounting",
        
        
         ACCOUNTING_TYPE_1_NAME : "Decentralized",
         ACCOUNTING_TYPE_2_NAME : "Ho - branch centralized & decentralised franchise",
         ACCOUNTING_TYPE_3_NAME : "Centralized",
        
        
    
         CARD : "card",
         BANK : "bank",
         TAX : "tax",
         GENERAL_SETTINGS : "generalsetting",
         GST : "gst",
         VAT : "vat",
    
         TAX_TYPE_GST : 0,
         TAX_TYPE_VAT : 1,
    
        // -----------------SALES---------------------
         SALES_ORDER : "order",
         SALES_INVOICE : "invoice",
         SALES2_INVOICE : "estimate2",
         SALES_BILL_OF_SUPPLY : "billofsupply",
         SALES_ESTIMATE : "estimate",
         SALES_DELIVERY_CHALLAN : "deliverychallan",
         SALES_CREDIT_NOTE : "creditnote",
         POS_CREDIT_NOTE : "poscreditnote",
         SALES_POS : "pos",
         SALES_POS_ONLINE : "posonline",
         SALES_POS_FOR_PERM : "POS",
         POS_NEW : "posnew",
         SALES_POS_RETURN : "posreturn",
         PURCHASE: "purchase",
         PRODUCT_SHEET : "productsheet",
         SALES : "sales",
        // bill of materials
         BIL_OF_MATERIALS : "billofmaterials",
    
        // recipe // like a job work
         RECIPE : "recipe",
    
        // -----------------PURCHASE---------------------
         PURCHASE_ORDER : "order",
         PURCHASE_BILL : "bill",
         PURCHASE_DEBIT_NOTE : "debitnote",
         PURCHASE_MATERIALINWARD : "materialinward",
    //	 STOCKBYMI : "stockbymi",
    //	 STOCKBYBILL : "stockbybill",
    
        // use this switch in purchase 0<- Purchase Bill, 1<- Material Inward, 2<- BOTH
         ADDQTYBY : "addqtyby",
        
        // use this switch in first created basis->3, salesinvoice->0, sales DC->2
         B2BSTOCKOUT : "b2bstockout",
    
         PURCHASE_GST_TAX_TYPE_TAXDEFAULT : "taxdefault",
         PURCHASE_GST_TAX_TYPE_TAXINCLUSIVE : "taxinclusive",
         PURCHASE_GST_TAX_TYPE_TAXEXCLUSIVE : "taxexclusive",
    
         SUPPLIER_BILL : "suppilerbill",
        // -----------------CONTACT---------------------
         CONTACT : "contact",
         CONTACT_CUSTOMER : "customers",
         CONTACT_SUPPLIER : "suppliers",
    
         CONTACT_CATEGORY_RETAILER : "retailer",
         CONTACT_CATEGORY_WHOLESALER : "wholesaler",
         CONTACT_CATEGORY_OTHER : "other",
         CONTACT_CATEGORY_MRP : "mrp",
         CONTACT_CATEGORY_MERCHANT : "merchant",
    
         CONTACT_CATEGORY_MANUFACTURER : "manufacturer",
         CONTACT_CATEGORY_STOCKIEST : "stockiest",
         CONTACT_CATEGORY_TRADER : "trader",
    
         CONTACT_AGENT : "agent",
         CONTACT_TRANSPORT : "transport",
         CONTACT_SALESMAN : "salesman",
         CONTACT_VENDORS : "vendors",
         CONTACT_LABOUR : "labour",
    
        // -----------------JOB WORK---------------------
         JOBWORK : "jobwork",
         JOBWORK_RECEIVE : "jobwork_receive",
         JOBWORK_PAYMENT : "jobwork_payment",
    
         BANK_TRANSACTION : "bank_transaction",
         BANK_WITHDRAW : "withdraw",
         BANK_DEPOSIT : "deposit",
         BANK_TRANSFER : "transfer",
    
         CASH_FLOW_TRANSACTION : "CASH_FLOW_TRANSACTION",
         MANAGER_CASH_FLOW_TRANSACTION : "MANAGER_CASH_FLOW_TRANSACTION",
         INTERNALTRANSFER_TRANSACTION : "internaltransfer_transaction",
         INTERNALTRANSFER_TRANSACTION_WITHDRAW : "internaltransfer_transaction_withdraw",
         INTERNALTRANSFER_TRANSACTION_TRASNFER : "internaltransfer_transaction_trasnfer",
         CASH_FLOW_WITHDRAW : "withdraw",
         CASH_FLOW_DEPOSIT : "deposit",
         CASH_FLOW_TRASNFER : "trasnfer",
    
        // -----woocommerce------//
         ALLOWPRODUCTTOSYNCINWOOCOMMERCEWITHOUTIMAGE : "allowproducttosyncinwoocommercewithoutimage",
         ALLOWWOOCOMMERCEDEFAULTIMAGE : "allowwoocommercedefaultimage",
         ALLOWOGOSHOPDEFAULTIMAGE : "allowogoshopdefaultimage",
    
         GETALLPRODUCTSWITHFILTER : "/wp-json/wc/v3/products?per_page:50&page:",
        // -----woocommerce------//
    
         PRODUCT_DEFAULT_IMAGE : "default_image",
        
        // -----------------ACCOUNT GROUP---------------------
         ACCOUNT_GROUP_CURRENT_ASSETS : 1,
         ACCOUNT_GROUP_CURRENT_LIABILITIES : 2,
         ACCOUNT_GROUP_FIXED_ASSETS : 3,
         ACCOUNT_GROUP_DIRECT_INCOMES : 4,
         ACCOUNT_GROUP_INDIRECT_INCOMES : 5,
         ACCOUNT_GROUP_INDIRECT_EXPENSES : 6,
         ACCOUNT_GROUP_DIRECT_EXPENSES : 7,
         ACCOUNT_GROUP_BANK_ACCOUNT : 8,
         ACCOUNT_GROUP_LOANS_AND_LIABILITIES : 9,
         ACCOUNT_GROUP_BRANCH_AND_DIVISION : 10,
         ACCOUNT_GROUP_CAPITAL_ACCOUNT : 11,
         ACCOUNT_GROUP_CASH_IN_HAND : 12,
         ACCOUNT_GROUP_STOCK_IN_HAND : 13,
         ACCOUNT_GROUP_SUNDRY_CREDITORS : 14,
         ACCOUNT_GROUP_SUNDRY_DEBTORS : 15,
         ACCOUNT_GROUP_SALES_ACCOUNT : 16,
         ACCOUNT_GROUP_DUTIES_AND_TAXES : 17,
         ACCOUNT_GROUP_INVESTMENT : 18,
         ACCOUNT_GROUP_PURCHASE_ACCOUNT : 19,
         ACCOUNT_GROUP_OTHER_CURRENT_ASSETS: 20,
         ACCOUNT_GROUP_CAPITAL: 21,
         ACCOUNT_GROUP_SALARY_PAYABLE: 22,
         ACCOUNT_GROUP_OTHER_CURRENT_LIABILITIES: 23,
         ACCOUNT_GROUP_BANK_OD_AC : 24,
         ACCOUNT_GROUP_DEPOSITS_ASSET: 25,
         ACCOUNT_GROUP_LOANS_AND_ADVANCES_ASSET : 26,
         ACCOUNT_GROUP_PROVISIONS: 27,
         ACCOUNT_GROUP_RESERVES_AND_SURPLUS: 28,
         ACCOUNT_GROUP_SECURED_LOANS: 29,
         ACCOUNT_GROUP_UNSECURED_LOANS: 30,
         ACCOUNT_GROUP_DEPRECIATION_AND_AMORTISATION: 31,
         ACCOUNT_GROUP_ADMINISTRATION_AND_GENERAL_EXPENSE: 32,
         ACCOUNT_GROUP_EMPLOYEE_BENEFIT_EXPENSE	: 33,
         ACCOUNT_GROUP_FINANCE_COS : 34,
         ACCOUNT_GROUP_SALES_AND_MARKETING_EXPENSES: 35,
         ACCOUNT_GROUP_SALES: 36,
         ACCOUNT_GROUP_SALES_RETURN: 37,
         ACCOUNT_GROUP_PURCHASE: 38,
         ACCOUNT_GROUP_PURCHASE_RETURN: 39,
    
    
    
        // -----------------ACCOUNT---------------------
         ACCOUNT_GROUP : "accountgroup",
         ACCOUNT_ASSETS : "Assets",
         ACCOUNT_LIABILITIES : "Liabilities",
         ACCOUNT_EXPENSES : "Expenses",
         ACCOUNT_Income : "Income",
         ACCOUNT_SALES : "Sales",
         ACCOUNT_SALES_RETURN : "Sales Return",
         ACCOUNT_PURCHASE : "Purchase",
         ACCOUNT_PURCHASE_RETURN : "Purchase Return",
         ACCOUNT_DISCOUNT_RECEIVED : "Discount Received",
         ACCOUNT_CASH : "Cash",
         ACCOUNT_PETTY_CASH : "Petty Cash",
         ACCOUNT_ROUNDOFF_INCOME : "Roundoff Income",
         ACCOUNT_ROUNDOFF_EXPENSE : "Roundoff Expense",
         ACCOUNT_DISCOUNT_GIVEN : "Discount Given",
         ACCOUNT_KASAR : "Kasar",
         CESS_TAX : "Cess Tax",
         ACCOUNT_IGST : "IGST",
         ACCOUNT_CGST : "CGST",
         ACCOUNT_SGST : "SGST",
         ACCOUNT_VAT : "VAT",
    //	 ACCOUNT_ADVERTISEMENT_EXPENSES : "Advertisement Expenses",
    //	 ACCOUNT_BANK_CHARGES : "Bank Charges",
    //	 ACCOUNT_BANK_COMMISSION : "Bank Commission",
    //	 ACCOUNT_BANK_LOAN : "Bank Loan",
    //	 ACCOUNT_COFFEE_AND_TEA_EXPENSES : "Coffee/Tea Expenses",
    //	 ACCOUNT_ELECTRICITY_EXPENSES : "Electricity Expenses",
    //	 ACCOUNT_INSURANCE : "Insurance",
    //	 ACCOUNT_LABOUR_CHARGES : "Labour Charges",
    //	 ACCOUNT_LOSS_BY_DAMAGE : "Loss By Damage",
    //	 ACCOUNT_LOSS_BY_FIRE : "Loss by Fire",
    //	 ACCOUNT_OFFICE_EXPENSES : "Office Expenses",
    //	 ACCOUNT_PETROL_EXPENSES : "Petrol Expenses",
    //	 ACCOUNT_ADVERTISEMENT : "Advertisement",
    //	 ACCOUNT_STATIONERY : "Stationery",
    //	 ACCOUNT_SALARY : "Salary",
    //	 ACCOUNT_SHOP_EXPENSES : "Shop Expenses",
    //	 ACCOUNT_SHOP_RENT : "Shop Rent",
    //	 ACCOUNT_TELEPHONE_EXPENSES : "Telephone Expenses",
    //	 ACCOUNT_TELEPHONE_SECURITIES : "Telephone Securities",
    //	 ACCOUNT_TRADE_EXPENSES : "Trade Expenses",
    //	 ACCOUNT_TRAIN_FREIGHT_AND_RENT : "Train Freight & Rent",
    //	 ACCOUNT_TRAVELLING_EXPENSES : "Traveling Expenses",
    
         PRODUCT_TYPE_LIST : ["Finished","SemiFinished","Packaging","Raw"],
        
    //	 ACCOUNT_RESERVE_LIST : ["Advertisement Expenses", "Bank Charges",
    //			"Bank Commission", "Bank Loan", "Coffee/Tea Expenses", "Electricity Expenses", "Insurance",
    //			"Labour Charges", "Loss By Damage", "Loss by Fire", "Office Expenses", "Petrol Expenses", "Advertisement",
    //			"Stationery", "Salary", "Shop Expenses", "Shop Rent", "Telephone Expenses", "Telephone Securities",
    //			"Trade Expenses", "Train Freight & Rent", "Traveling Expenses", "Discount Received", "Cash", "Petty Cash",
    //			"Sales", "Sales Return", "Purchase", "Purchase Return", "Roundoff Income", "Roundoff Expense",
    //			"Discount Given", "Kasar", "Cess Tax"),
    
     ACCOUNT_RESERVE_LIST : ["Discount Received", "Cash", "Petty Cash",
                "Sales", "Sales Return", "Purchase", "Purchase Return", "Roundoff Income", "Roundoff Expense",
                "Discount Given", "Kasar", "Cess Tax"],
    
         PAYMENT : "payment",
         RECEIPT : "receipt",
         SETTING : "SETTINGS",
         RECEIPT_VOUCHER : "Receipt",
    
         PAYMENT_TYPE_ADVANCE : "AdvancePayment",
         PAYMENT_TYPE_ONACCOUNT : "OnAccount",
         PAYMENT_TYPE_AGAINSTBILL : "AgainstBill",
    
         TERMSCONDITION : "termscondition",
         PREFIX : "prefix",
         ADDITIONALCHARGE : "additionalcharge",
         HARDWARE : "hardware",
         REPORTSETTING : "reportsetting",
         SENDEMAIL : "smsemail",
         TERM : "term",
         PAYMENTTERMS : "term",
         MEMBERSHIPMASTER : "membershipmaster",
    
         REALPATH : "https://s3-us-west-2.amazonaws.com/",
    
        // --------------------admin-------------------
    
         CORPORATES : "corporates",
         COMPLAIN : "complain",
         BUSINESS : "business",
         PACKAGE : "package",
         ADDONS : "addons",
         APPS : "apps",
         MODULE : "module",
         SECTOR : "sector",
         DEALER : "dealer",
         DEPARTMENT : "department",
         PAYMENTMASTER : "paymentmaster",
         GLOBAL_ROLE : "global_role",
         LOCATION_COUNTRIES : "location_countries",
         LOCATION_STATE : "location_state",
         LOCATION_ZONE : "location_zone",
         LOCATION_CITY : "location_city",
         CURRENCY : "currency",
         GLOBAL_USER : "global_user",
         ENQUIRY : "enquiry",
         SUPPORT : "support",
        
         PACKAGE_HOLD  : "hold",
         PACKAGE_START  : "start",
    
         GLOBAL_INSERT : 1,
         GLOBAL_EDIT : 2,
         GLOBAL_VIEW : 3,
         GLOBAL_DELETE : 4,
    
        // -------STOCK TrANSFER STATUS ------------:-
         STOCK_TRANSFER_APPROVE : "approve",
         STOCK_TRANSFER_REJECTED : "rejected",
         STOCK_TRANSFER_OPEN : "open",
    
         AVAILABLE : "Available",
         REDEEMED : "Redeemed",
    
        // -------SHOPIFY ------------:-
         GRETER_THEN_OR_EQUAL_TO : "GRETER_THEN_OR_EQUAL_TO",
    
        // --------------sms setting -------
         MSG91_SMS_PROVIDER : "MSG91",
         TEXT_LOCAL_SMS_PROVIDER : "TEXT-LOCAL",
         TWILLO_SMS_PROVIDER : "TWILLO",
         SMS_JUST_SMS_PROVIDER : "SMS-JUST",
         RETAIL_CORE_SMS_PROVIDER : "RETAIL-CORE",
         SMS_EZEESMS : "EZEESMS",
         INTERAKT_WHATSAPP_PROVIDER : "INTERAKT",
    
         VISITORPASS : "visitorpass",
    
        // notification
         STOCKALERT : "stock",
         PAYMENTREMINDER : "payment",
         BIRTHDAY : "birthday",
         ANNIVERSARY : "anniversary",
         OTHER : "other",
         OTHER_CAPITAL : "OTHER",
    
        // company drive pdf download path
         BUCKET_NAME : "vasy5",
         DRIVE_NAME : "Gmart/companydrive",
    
         PREDEFINE_PRODUCT_ATTRIBUTE : "predefineproductattribute",
         PRODUCT_BRAND_ATTRIBUTE : "Brand",
         PRODUCT_DEPARTMENT_ATTRIBUTE : "Department",
        //  WHATSAPP_API_BASE :
        // "http://whatsapp.croodstech.com/api/v1/whatsapp",
         WHATSAPP_API_AUTH : "/auth",
         WHATSAPP_API_LOGIN : "/login",
         WHATSAPP_API_SENDTEXT : "/send/text",
         WHATSAPP_PASSWORD : "83e4060e-78e1-4fe5-9977-aeeccd46a2b8",
         WHATSAPP_API_SENDDOC : "/send/document",
         WHATSAPP_API_SENDIMAGE : "/send/image",
         WHATSAPP_API_SENDAUDIO : "/send/audio",
         WHATSAPP_API_SENDVIDEO : "/send/video",
    
         ALLOWPOSOTHER : "allowposother",
         ALLOWPOSOTHERMSG : "allowposothermsg",
    
         INSTAMOJO_BASE_TEST : "https://test.instamojo.com/api/1.1/",
         INSTAMOJO_BASE_LIVE : "https://www.instamojo.com/api/1.1/",
         INSTAMOJO_PAY_REQ : "payment-requests/",
    
         PAYMENT_TYPE_PAYTM : "paytm",
         PAYMENT_TYPE_CASHFREE : "cashfree",
         PAYMENT_TYPE_RAZORPAY : "razorpay",
         PAYMENT_TYPE_INSTAMOJO : "instamojo",
         ONLINE : "online",
    
         SHPOIFYCHECKCREDENTIALS : "/admin/shop.json",
         SHPOIFYGETPRODUCT : "/admin/products.json",
         SHPOIFYPOSTPRODUCT : "/admin/products.json",
         SHPOIFYPUTPRODUCT : "/admin/products/",
         SHPOIFYDELETEIMAGE : "/admin/products/",
         SENDSMSFORSTOCKTRANSFER : "sendsmsforstocktransfer",
         LINEDISPLAY : "linedisplay",
         POSCUSTOMERSEARCHWITHADDRESS : "poscustomersearchwithaddress",
    
        // -----------------deliveryCharge
         DELIVERYCHARGES : "deliveryCharges",
         INVENTORYTRACKING : "inventoryTracking",
         INVENTORY_TRACKING_APPROVE : "approve",
         INVENTORY_TRACKING_PENDING : "pending",
         SELFCHECKOUT : "self-checkout",
         OGOSHOP : "ogoshop",
    
         LOYALTY : "loyalty",
    
         LOYALTYCHECKCREDENTIALS : "checkApi",
         LOYALTYGETPOINTS : "getpoints/",
         LOYALTYCAPTUREBIL : "capturebil",
         LOYALTYPRELOADINGPOINT : "addpreloadingpoint",
         LOYALTYUPDATEBIL : "updatebil",
         LOYALTYREVERTBILL : "revertbill",
         LOYALTYGETCOUPON : "getcoupon/",
         LOYALTYREDEEMCOUPON : "redeemcoupon",
         LOYALTYSENDOTP : "otpverifications/sendotp",
         HIDEPOSPRODUCTTAB : "hideposproducttab",
         STOCKMASTERQTYUPDATE : "stockmasterqtyupdate",
         FOCUSONPOS : "focusonpos",
         VIEWALLORDERS : "viewallorders",
    
         ALLOWPRODUCTDUPLICATIONVALIDATION : "allowproductduplicationvalidation",
         SCANDITLICENSEKEY : "scanditlicensekey",
         ALLOWCUSTOMERBIRTHDAYOFFERSMS : "allowcustomerbirthdayoffersms",
         RESTAURANTMANAGEMENT : "restaurantmanagement",
         WAITERAPP : "waiterapp",
         KOTORDER : "kotorder",
         KOT : "kot",
         STOCKVERIFICATIONSCANDITLICENSEKEY : "stockverificationscanditlicensekey",
         KOTPRINT : "kotprint",
         POSTOKENNO : "postokenno",
         EXCHANGE : "exchange",
         REMOVEBUTTONCOUPON : "removebuttoncoupon",
         LOYALTYBEHAVIOUR : "loyaltybehaviour",
         ALLOWROUNDOFF : "allowroundoff",
         BRANCHMODULE : "branchmodule",
    
         SERVICEABLEAREA : "serviceablearea",
         PRINTTHERMAL : "printthermal",
         PRINTA5 : "printA5",
    
         JASPER : "jasper",
         HTML : "html",
    
        // --------report type----------------ravi //
         REPORT_SALES : "sales",
         REPORT_PURCHASE : "purchase",
         REPORT_INVENTORY : "inventory",
         REPORT_ACCOUNT : "account",
         REPORT_STOCK : "stock",
         REPORT_PRODUCT : "product",
         REPORT_OUTSTANDING : "outstanding",
         REPORT_BANK : "bank",
         REPORT_OTHER : "other",
         REPORT_GST : "gst",
         REPORT_POS : "pos",
    
         COMMONPAYMENTTYPESALES : "sales",
         COMMONPAYMENTTYPEPURCHASE : "purchase",
         COMMONPAYMENTTYPEEXPENSE : "expense",
    
        // reelo
    
    //demo
         REELO : "reelo",
        //  REELOCUSTOMERKEY : "1d2f4hgj",
        //  REELOMERCHANTKEY :
        // "d799c23517fc313042554ca4d9740343",
    //		
    
        //  REELOCAPTUREBILL : "vendor/capture_bill",
         REELOBASEURL : "/v1/pos/integrations/",
         REELOCAPTUREBILL : "/bill/customer",
         REELOUPDATE_BILL : "/update-bill",
         REELOCONTACTLOYALITY : "/rewards/customer",
         REELOGETCUSTOMERLOYALTYDETAILS : "/rewards/customer",
         REELOCONTACTLOYALITY2 : "/rewards/customer",
         REELOBILLTYPE : "DINE-IN",
         REELOREVERTPOINTS : "/revert-points",
         REELOSENDOTP : "/points/authenticate",
         REELOREDEEMCOUPON : "/redeem/coupon",
         REELOUPDATEMENU : "v1/pos/integrations/",
         REELOCUTOMERLOYALTYDETAILS : "/customer_loyalty_details",
         REELOREDEEMPOINTS : "/redeem/points",
    
         REEPURPOSEREDEEMLOYALTYPOINTTIER : "redeem_loyalty_point_tier",
    
         ALLOWPRODUCTCREATEANYWHERE : "allowproductcreateanywhere",
         HOLDBILL : "holdbill",
         REEDEMLOYALTY : "reedemloyalty",
         ADDPAYMENT : "addpayment",
         ADDITIONALDISCOUNT : "additionaldiscount",
         APPLYECOUPON : "applyecoupon",
         REDEEMCREDIT : "redeemcredit",
         SHOWPROFITINSALESREGSITER : "showprofitinsalesregsiter",
         SALESGARMENTDESIGN : "salesgarmentdesign",
         SALESDELIVERYCHALANSTOCK : "salesdeliverychalanstock",
    
         MULTIPAY : "multipay",
         UPI : "upi",
         CASH : "cash",
         PAYLATER : "paylater",
         HOLDANDPRINT : "holdandprint",
         UPIANDPRINT : "upiandprint",
         CARDANDPRINT : "cardandprint",
         CASHANDPRINT : "cashandprint",
         QTY : "qty",
         MRP : "mrp",
         TAXAMOUNT : "taxamount",
         FLATDISCOUNT : "flatdiscount",
         ROUNDOFF : "roundoff",
         BILLDISCOUNT : "billdiscount",
         ITEMCODE : "itemcode",
         CREDITNOTE : "creditnote",
         ORDERS : "orders",
         LASTBILL : "lastbill",
         ORDERTYPE : "ordertype",
         OTPPAYLATER : "OTPPAYLATER",
         SALESMAN : "salesman",
         CUSTOMERDETAILS : "customerdetails",
    
        /// product sheet
         SHEETDEPARTMENT : 0,
         SHEETCATEGORY : 1,
         SHEETSUBCATEGORY : 2,
         SHEETBRAND : 3,
         SHEETSUBBRAND : 4,
         SHEETITEMCODE : 5,
         SHEETPRODUCTNAME : 6,
         SHEETPRINTNAME : 7,
         SHEETSHORTDESCRIPTION : 8,
         SHEETDESCRIPTION : 9,
         SHEETMEASURMENTNAME : 10,
         SHEETMEASURMENTCODE : 11,
         SHEETHSNCODE : 12,
         SHEETSALESTAXNAME : 13,
         SHEETSALESTAXRATE : 14,
         SHEETPURCHASETAXNAME : 15,
         SHEETPURCHASETAXRATE : 16,
         SHEETSALESTAXINCLUDING : 17,
         SHEETPURCHASETAXINCLUDING : 18,
    //	 SHEETDESIGNNO : 18,
         SHEETHAVEVARIENT : 19,
         SHEETVARIENTNAME : 20,
         SHEETMRP : 21,
         SHEETPURCHASEPRICE : 22,
         SHEETDISCOUNTYTPE : 23,
         SHEETDISCOUNT : 24,
         SHEETQTY : 25,
         SHEETEXPIRATIONDAYS : 26,
         SHEETNETWEIGHT : 26,
         SHEETINGREDIENTS : 27,
    
        
        // :::::membership sheet:::::::::::://
         SHEETMEMBERSHIP : 28,
         SHEETMEMBERSHIPTYPE : 29,
         SHEETMARGIN : 30,
         SHEETMARGINETYPE : 31,
    
        /// bulk product sheet
         BULKSHEETPRODUCTNAME : 0,
         BULKSHEETVARIENTNAME : 1,
         BULKSHEETPRINTNAME : 2,
         BULKSHEETITEMCODE : 3,
         BULKSHEETSHORTDESCRIPTION : 4,
         BULKSHEETDESCRIPTION : 5,
         BULKSHEETPURCHASEPRICE : 6,
         BULKSHEETMRP : 7,
         BULKSHEETDISCOUNT : 8,
         BULKSHEETDISCOUNTYTPE : 9,
         BULKSHEETPURCHASETAXNAME : 10,
         BULKSHEETPURCHASETAXRATE : 11,
         BULKSHEETSALESTAXNAME : 12,
         BULKSHEETSALESTAXRATE : 13,
         BULKSHEETDEPARTMENT : 14,
         BULKSHEETCATEGORY : 15,
         BULKSHEETSUBCATEGORY : 16,
         BULKSHEETHSNCODE : 17,
         BULKSHEETSALESTAXINCLUDING : 18,
         BULKSHEETPURCHASETAXINCLUDING : 19,
         BULKSHEETMEASURMENTNAME : 20,
         BULKSHEETMEASURMENTCODE : 21,
         BULKSHEETMEASURMENTDECIMAL : 22,
         BULKSHEETBRAND : 23,
         BULKSHEETBRANDCODE : 24,
         BULKSHEETSUBBRAND : 25,
         BULKSHEETCESS : 26,
         BULKSHEETCESSRATE : 27,
         BULKSHEETEXPIRATIONDAYS : 28,
         BULKSHEETNETWEIGHT : 29,
         BULKSHEETINGREDIENTS : 30,
        
         BULKSHEETPOQTY : 31,
         BULKSHEETSTOCKLIMIT : 32,
        
        
         BULKSHEETMEMBERSHIP : 31,
         BULKSHEETMEMBERSHIPTYPE : 32,
         BULKSHEETMARGIN : 33,
         BULKSHEETMARGINETYPE : 34,
    
        // Conversation
         PURCHASECONVERSATION : "purchaseconversation",
         PURCHASECONVERSATIONList : "purchaseconversationlist",
    
         ALLOWDUPLICATEPRODUCTINSALES : "allowduplicateproductinsales",
         CUSTOMERNAME : "customername",
    
        // START---------------------SMS TYPE------------------------------START//
    
         SMSFOR_ADMIN : "admin",
         SMSFOR_USER : "user",
    
        // sales sms//
         SMS_SALESORDER : "SALES ORDER",
         SMS_INVOICE : "INVOICE",
         SMS_SALES_CREDIT_NOTE : "SALES CREDIT NOTE",
        // sales sms//
        // pos sms//
         SMS_POS : "POS",
         SMS_POS_ORDER_DELETE_MESSAGE : "POS ORDER DELETE",
         SMS_POS_ORDER_CONFORM : "POS ORDER CONFORM",
         SMS_POS_COUNTER_START : "POS COUNTER START",
         SMS_CLOSE_REGISTER_SMS : "CLOSE REGISTER SMS",
         SMS_ORDERRECEIVEDADMIN : "ORDER RECEIVED ADMIN",
        // pos sms//
        // self checkout sms//
         SMS_SELFCHECKOUT : "SELF CHECKOUT",
         SMS_SELF_CHECKOUT_ORDER_ADMIN : "SELF CHECKOUT ORDER ADMIN",
        // self checkout sms//
        // purchase sms//
         SMS_PURCHASEORDER : "PURCHASE ORDER",
         SMS_PURCHASEBILL : "PURCHASE BILL",
        // purchase sms//
         SMS_STOCK_TRANSFER_SMS_ACCEPT_SMS : "STOCK TRANSFER SMS ACCEPT",
    
         SMS_BIRTHDAY : "BIRTHDAY",
         SMS_ANNIVERSARY : "ANNIVERSARY",
    
        // END---------------------SMS TYPE------------------------------END//
         REDEEM : "redeem",
         POBYSALESQTY : "pobysalesqty",
    
         API_RESPONSE_STATUS_200 : "200",
         API_RESPONSE_STATUS_500 : "500",
         API_RESPONSE_STATUS_400 : "400",
         API_RESPONSE_STATUS_404 : "404",
         OPEN : "open",
         METHOD_RAZORPAY : "razorpay",
         METHOD_COD : "cod",
         APPSTATUS_ORDERPLACED : "orderplaced",
         STOCKADJUSTMENT : "stockadjustment",
         STOCKRESET:"stockreset",
        // --------------------API Constant----------------------
    
         AGENTNAME : "agentname",
         X_APIKEY : "x-apikey",
         AGENTNAME_NOT_Provide : "AgentName is not provided.",
         X_APIKEY_NOT_Provide : "X-APIKEY is not provided.",
         AGENTNAME_X_APIKEY_NOT_Valid : "AgentName or X-APIKEY is not Valid.",
        // header Constant
         XAPIKEY : "33340e2f-2cde-4fbf-b633-b8859adc5c25",
         REACTXAPIKEY : "55540e2f-2cde-4fbf-b633-b8859adc5c50",
         AgentName : "MPOS",
         reactAgentName : "REACTPOS",
         ALLOWPROMOTIONALSMS : "allowpromotionalsms",
         SHEETFIRSTNAME : 0,
         SHEETLASTNAME : 1,
         SHEETCOMPANYNAME : 2,
         SHEETMOBILENO : 3,
        
         SHEETWHATSAPPNO : 4,
        
        
         SHEETEMAIL : 5,
         SHEETTELEPHONE : 6,
    //	 SHEETDATEOFBIRTH:6,
         SHEETGSTTYPE : 7,
         SHEETGSTIN : 8,
         SHEETPANNO : 9,
         SHEETTYPE : 10,
         SHEETBANKNAME : 11,
         SHEETBRANCHNAME : 12,
         SHEETBANKACCNO : 13,
         SHEETIFSC : 14,
         SHEETADDRESS1 : 15,
         SHEETADDRESS2 : 16,
         SHEETPINCODE : 17,
         SHEETCITYCODE : 18,
         SHEETSTATECODE : 19,
         SHEETCOUNTRYCODE : 20,
         DOB : 21,
         OPENINGBALANCE : 22,
         CRORDR : 23,
         CONTACTSHEETREASON : 24,
         OPENINGSTOCKSHEETREASON : 7,
        
         APPSTATUS_ORDERACCEPTED : "orderaccepted",
         APPSTATUS_DISPATCHED : "dispatched",
         APPSTATUS_SHIPPED : "shipped",
         APPSTATUS_OUTFORDELIVERY : "outfordelivery",
         APPSTATUS_DELIVERED : "delivered",
         APPSTATUS_CALCELED : "canceled",
    
         PAYTMQRCODE : "paytmqrcode",
         MAPPINGSTOCKMINUS : "mappingstockminus",
    
         Finished : "Finished",
         SemiFinished : "SemiFinished",
         Packaging : "Packaging",
         Raw : "Raw",
    
        // ::::::::::::B2B:::::::::::::::::://
         ALLOWB2B : "allowb2b",
        
         PARTIALLY_CANCELLED: "Partially Cancelled",
         CANCELLED : "Cancelled",
         PENDING : "pending",
         ORDER_CREATED : "Order Created",
        
         INVOICE_CREATED : "Invoice Created",
         INVOICED : "Invoiced",
         PARTIAL_INVOICE_CREATED : "Partial Invoice Created",
        // PARTIALLY_INVOICED : "Partially Invoiced",
        
         DC_CREATED : "Delivery Challan Created",
         DELIVERED : "Delivered",
         PARTIAL_DC_CREATED : "Partial Delivery Challan Created",
        // PARTIALLY_DELIVERED : "Partially Delivered",
        
    
        // material gate pass
         MATERIALGATEPASS : "materialgatepass",
         ACCESSDENIED : "accessdenied/accessdenied",
         RETURNABLE : "Returnable",
         NONRETURNABLE : "Non-Returnable",
         GATEPASSPENDING : "Pending",
         DUE : "Due",
         COMPLETED : "Completed",
    
         ALLOWPOSTOKEN : "allowpostoken",
         API_KEY : "api-key",
         NOTIFICATION_SALES : "sales",
         NOTIFICATION_PURCHASE : "purchase",
         NOTIFICATION_STOCK : "stock",
         NOTIFICATIONPAYMENTREMINDER : "notificationpaymentreminder",
    
         WOO_ATSYNC : "atsync",
         WOO_SYNC_COMPLETED : "sync_completed",
         WOO_SYNC_FAILED : "sync_failed",
         MATERIALCREATION : "materialcreation",
    
         A4 : "A4",
         A5 : "A5",
         THERMAL : "THERMAL",
        //  REELO_VASY_ACCEDDKEY :
        // "360b3e0a-5e80-4764-abc7-490e12827b03",
         REELO_VASY_ACCEDDKEY : "ce5e2b9c-7d41-4ff2-862d-99e16ad7d40c",
        // BARCODE UTILITY
         BARCODE_UTILITY : "barcodeutility",
    
        // PAYMENT INTEGRATION DEVICES TYPE
         PAYMENT_INTEGRATION_DEVICE_PINELABS : "pinelabs",
         PAYMENT_INTEGRATION_DEVICE_EZEYTAP : "ezeytap",
         PAYMENT_INTEGRATION_DEVICE_MSWIPE : "mswipe",
         PAYMENT_INTEGRATION_DEVICE_PAYTM : "paytm",
        // PINE LABS URL
    //	 PINELABS_BASE_URL : "https://www.plutuscloudserviceuat.in:8201", // testing url
    //	 PINELABS_BASE_URL : "https://www.plutuscloudservice.in:8201",
         PINELABS_UPLOAD_TRANSACTION_URL : "/API/CloudBasedIntegration/V1/UploadBilledTransaction",
         PINELABS_STATUS_URL : "/API/CloudBasedIntegration/V1/GetCloudBasedTxnStatus",
         PINELABS_CANCEL_URL : "/API/CloudBasedIntegration/V1/CancelTransaction",
    
        // :::::::::::::::Production:::::::::::::::::://
         PARTIALLY_DELIVERD : "partially_deliverd",
         DELIVERD : "deliverd",
         CLOSED : "closed",
         APPROVED : "approved",
         MATERIAL_EXCEED : "material_exceed",
         MATERIAL_PARTIALLY_CREATED : "material_partially_created",
         MATERIAL_COMPLETED : "material_completed",
         MATERIALRECEIVE_EXCEED : "materialreceive_exceed",
         MATERIALRECEIVE_PARTIALLY_CREATED : "materialreceive_partially_created",
         MATERIALRECEIVE_COMPLETED : "materialreceive_completed",
         PRODUCTION_COMPLETED : "production_completed",
         PRODUCTION_PARTIALLY_CREATED : "production_partially_created",
         PRODUCTION_EXCEED : "production_exceed",
    
         QCPACKING_COMPLETED : "qcpacking_completed",
         QCPACKING_PARTIALLY_CREATED : "qcpacking_partially_created",
         QCPACKING_EXCEED : "qcpacking_exceed",
    
         PRODUCTIONHOUSE : "Production House",
         MISSINGHOUSE : "Missing House",
         DAMAGEDHOUSE : "Damaged House",
        // :::::::::::::::Permission:::::::::::::::::://
         PRODUCTION : "production",
         PRODUCTIONPLANNING : "productionplanning",
         MATERIALISSUE : "materialissue",
         MATERIALRECEIVE : "materialreceive",
         EXCEED : "exceed",
         QCPACKING : "qcpacking",
         STOCKLOCATION : "stocklocation",
         CUSTOMERCATEGORY : "customercategory",
        // :::::::::::::::Permission:::::::::::::::::://
         REPORTBETA : "reportbeta",
    
        // :::::::::::::::Production:::::::::::::::::://
    
        //  DOCUMENTS : "documents",
         DRIVE : "drive",
         COMPANYSETTING : "companysetting",
         EMAILSETTING : "emailsetting",
         B2BPRODUCTSETTING : "b2bproductsetting",
        //  SMSLOG : "smslog",
         SMSTEMPLATE : "smstemplate",
    
         FINANCIALYEAR : "financialyear",
        //  ACTIVITYLOG : "activitylog",
         REPORT : "report",
         PURCHASETERMSANDCONDITION : "purchasetermsandcondition",
         SALESTERMSANDCONDITION : "salestermsandcondition",
    
        /*
         * 9 : HT (horizontal tab) 10 : LF (line feed - new line) 11 : VT (vertical tab)
         * 13 : CR (carriage return) 43 : + 45 : - 60 : < 61 : : 62 : > 64 : @
         * 
         */
         CSV_INJECTION_CHARACTERS : ["9", "10", "11", "13", "43", "45", "60",
                "61", "62"],
    
         DECIMALSETTINGS : "decimal_setting",
    
        /****** Forgot Password Temp Type Constants START *******/
         PASSWORD_TEMP_TYPE_MFA : "mfa",
         PASSWORD_TEMP_TYPE_FORGOT : "forgot_password",
         PASSWORD_TEMP_TYPE_SIGNUP : "signup",
    
        /****** Forgot Password Temp Type Constants END *********/
    
         ERROR_PAGE_404 : "error/error-404",
    
        /****** FILE VALIDATION CONSTANT START *********/
         FILE_IMAGE : "image",
         FILE_EXCEL : "excel",
         FILE_IMAGE_AND_PDF : "imagepdf",
         FILE_IMAGE_PDF_EXCEL_CSV : "imagepdfexcelcsv",
    
         MAX_FILE_SIZE_IMAGE : 10485760, // 10 MB
         MAX_FILE_SIZE_PDF_DOC_EXCEL : 10485760, // 10 MB
         MAX_FILE_SIZE_OTHER : 10485760, // 10 MB
    
         VALID_FILE_TYPE_IMAGE : ["image/jpeg", "image/png", "image/bmp"],
         VALID_FILE_TYPE_IMAGE_PDF : ["image/jpeg", "image/png",
                "application/pdf"],
         VALID_FILE_TYPE_EXCEL :["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
         VALID_FILE_TYPE_IMAGE_PDF_EXCEL_CSV : ["image/jpeg", "image/png",
                "application/pdf", "text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel"],
        /****** FILE VALIDATION CONSTANT END *********/
    
         FILE_UPLOAD_SERVER_S3 : "S3",
         FILE_UPLOAD_SERVER_AZURE : "AZURE",
    
    //	ACCESSDENINED TYPE STRING RESPONSE
         ACCESSDENIEDRESPONSE : "accessdenied",
    
         MAX_OTP_SEND_LIMIT : 5,
         LOGIN_MAX_OTP_SEND_LIMIT : 3,
         OTP_SEND_LIMIT_TYPE_SIGN_UP : "signup",
         OTP_VERIFY_LIMIT_TYPE_SIGN_UP : "signupverifyotp",
         OTP_SEND_LIMIT_TYPE_MFA : "mfa",
         OTP_SEND_LIMIT_TYPE_VERIFICATION_REQUIRED: "verificationrequired",
         OTP_SEND_LIMIT_TYPE_FORGOT_PASSWORD : "forgotpassword",
         OTP_SEND_LIMIT_TYPE_ACCOUNT_ACTIVATE : "accountactivate",
         OTP_SEND_LIMIT_TYPE_PAY_LATER : "paylater",
         OTP_SEND_LIMIT_TYPE_LOYALTY_WEB : "loyaltyweb",
         OTP_SEND_LIMIT_TYPE_REELO_WEB : "reeloweb",
         OTP_SEND_LIMIT_TYPE_B2B : "b2b",
         OTP_SEND_LIMIT_TYPE_LOYALTY_MPOS : "loyaltympos",
         OTP_SEND_LIMIT_TYPE_DELIVERY_BOY : "deliveryboy",
         OTP_SEND_LIMIT_TYPE_MPOS_FORGOTPASSWORD : "mposforgotpassword",
         OTP_SEND_LIMIT_TYPE_AJIOWHOLESALER_LOGIN : "ajiowholesalerlogin",
         OTP_SEND_LIMIT_CASH_CONTROL_OPENING_BALANCE : "cashcontrolopeningbalance",
         OTP_SEND_LIMIT_MOB_NO_VERIFICATION_FOR_VASY : "vasymobnoverification",
         POS_DUE_DATE_CHANGE : "duedatechange",
    
        // CITY MASTER
         CITY_MASTER : "citymaster",
    
        // #### EZEYTAP TRANSACTION STAUS CODES START ####
    
         P2P_DEVICE_RECEIVED : "P2P_DEVICE_RECEIVED",
         P2P_DEVICE_SENT : "P2P_DEVICE_SENT",
         P2P_STATUS_QUEUED : "P2P_STATUS_QUEUED",
         P2P_STATUS_IN_EXPIRED : "P2P_STATUS_IN_EXPIRED",
         P2P_DEVICE_TXN_DONE : "P2P_DEVICE_TXN_DONE",
         P2P_STATUS_UNKNOWN : "P2P_STATUS_UNKNOWN",
         P2P_DEVICE_CANCELED : "P2P_DEVICE_CANCELED",
         P2P_STATUS_IN_CANCELED_FROM_EXTERNAL_SYSTEM : "P2P_STATUS_IN_CANCELED_FROM_EXTERNAL_SYSTEM",
    
         MESSAGE_P2P_DEVICE_RECEIVED : "Notification received on POS device",
         MESSAGE_P2P_DEVICE_SENT : "If notification is sent to the device",
         MESSAGE_P2P_STATUS_QUEUED : "If notification is queued on the server",
         MESSAGE_P2P_STATUS_IN_EXPIRED : "On Notification expiration",
         MESSAGE_P2P_DEVICE_TXN_DONE : "Transaction completed on POS device, need to look at txn fields.",
         MESSAGE_P2P_STATUS_UNKNOWN : "PushToPay Notification Status is in Unknown state.",
         MESSAGE_P2P_DEVICE_CANCELED : "PushToPay Notification has been Canceled on Receiving device.",
         MESSAGE_P2P_STATUS_IN_CANCELED_FROM_EXTERNAL_SYSTEM : "Cancelled successfully by",
    
         P2P_INVALID_P2P_REQUEST_ID : "P2P_DEVICE_RECEIVED",
         P2P_DUPLICATE_CANCEL_REQUEST : "P2P_DUPLICATE_CANCEL_REQUEST",
         P2P_ALREADY_COMPLETED : "P2P_ALREADY_COMPLETED",
         P2P_ALREADY_SKIPPED_ON_USER_END : "P2P_ALREADY_SKIPPED_ON_USER_END",
         P2P_PAYMENT_INITIATED : "P2P_PAYMENT_INITIATED",
         P2P_NOTIFICATION_EXPIRED : "P2P_NOTIFICATION_EXPIRED",
    
         MESSAGE_P2P_INVALID_P2P_REQUEST_ID : "Invalid P2P Request Id ",
         MESSAGE_P2P_DUPLICATE_CANCEL_REQUEST : "Cancellation already initiated, Duplicate Request",
         MESSAGE_P2P_ALREADY_COMPLETED : "Transaction already completed, can't initiate cancellation.",
         MESSAGE_P2P_ALREADY_SKIPPED_ON_USER_END : "Transaction already skipped on user end, can't initiate cancellation.",
         MESSAGE_P2P_PAYMENT_INITIATED : "Transaction already initiated, can't initiate cancellation.",
         MESSAGE_P2P_NOTIFICATION_EXPIRED : "Transaction already expired, can't initiate cancellation.",
         REPORT_HEADER : "reportheader",
         REPORT_FOOTER : "reportfooter",
    
         GENERALSETTING : "generalsetting",
         INVENTORYSETTING : "inventorysetting",
         POSSETTING : "possetting",
         NOTIFICATIONSSETTING : "notificationssetting",
         PURCHASESETTING : "purchasesetting",
         SALESSETTING : "salessetting",
         INTEGRATIONSETTING : "integrationsetting",
         LOGSSETTING : "logssetting",
         ECOMMERCESETTING : "ecommercesetting",
    
         SETTINGPRICING : "settingpricing",
         SETTINGSTOCK : "settingstock",
         SETTINGBARCODES : "settingbarcodes",
         SETTINGPRODUCTION : "settingproduction",
         SETTINGB2B : "settingb2b",
    
         SETTINGSMSLOG : "settingsmslog",
         SETTINGACTIVITYLOG : "settingactivitylog",
    
         SETTINGLOCALITY : "settinglocality",
         SETTINGDELIVERYPARTNERS : "settingdeliverypartners",
    
         SETTINGECOMMERCE : "settingecommerce",
         SETTINGPAYMENT : "settingpayment",
         SETTINGMESSAGE : "settingmessage",
         SETTINGLOYALTY : "settingloyalty",
         SETTINGGST : "settinggst",
    
        // #### EZEYTAP TRANSACTION STAUS CODES END ####
    
         CUSTOMERDETAILSMANDATORY : "customerdetailsmandatory",
    
         WOOCOMMERCE_CANCELLED : "cancelled",
    
        // SHOPIFY UPDATED CONSTANTS
    
         SHOPIFYSETCUSTOMERADDRESS : "/admin/api/2020-10/customers/",
         SHOPIFYCOUNTPRODUCTS : "/admin/products/count.json",
         SHOPIFYINVENTORYLEVELS : "/admin/inventory_levels.json",
         SHOPIFYADJUSTINVENTORYLEVELS : "/admin/inventory_levels/adjust.json",
         SHOPIFYGETORDER : "/admin/orders/",
         SHOPIFYCOUNTORDERS : "/admin/orders/count.json",
         SHOPIFYGETORDERSBYCOUNT : "/admin/orders.json",
         SHOPIFYCUSTOMCOLLECTIONS : "/admin/custom_collections.json",
         SHOPIFYGETCOLLECTIONTYPE : "/admin/",
         SHOPIFYSMARTCOLLECTIONS : "/admin/smart_collections.json",
         SHOPIFYGETCUSTOMERS : "/admin/customers.json",
         SHOPIFYGETCUSTOMER : "/admin/customers/",
    
         CONTINUESELLINGWHENOUTOFSTOCK : "continuesellingwhenoutofstock",
        
         CASHIER_USERROLE_TYPES : ["customers","product","receipt","posnew","poscreditnote","POS","salesregister","posonline"],
         PURCHASE_MANAGER_USERROLE_TYPES : ["BANK_TRANSACTION","barcodeutility","bill","billofmaterials","category_brand","debitnote","department","discount","expense","inventoryTracking","materialconsumption","materialcreation","materialinward","order","payment","product","receipt","recipe","report","salesregister","stocktransfer","stocktransferrequest","suppliers","tax","unitofmeasurement","vendors"],
         ACCOUNT_MANAGER_USERROLE_TYPES : ["accounts","bank","BANK_TRANSACTION","bill","creditnote","credit_note_accounting","customers","debitnote","debit_note_accounting","deliverychallan","employee","estimate","expense","invoice","JOURNAL_VOUCHER","materialinward","mobilepos","order","payment","product","receipt","report","reportbeta","salesorder","salesregister","suppliers","transport","vendors"],
        
         CASHIER_USERROLE_PERMISSIONS  :  {
            customers : [2],
            product : [2],
            receipt : [2],
            posnew : [1,2],
            poscreditnote : [1,2],
            POS : [1,2],
            salesregister : [2],
            posonline : [1,2],
        },
        
         PURCHASE_MANAGER_USERROLE_PERMISSIONS  :  {
            suppliers :[1,2,3],
            vendors :[1,2,3],
            product :[1,2,3],
            category_brand :[1,2,3],
            unitofmeasurement :[1,2,3],
            tax :[1,2,3],
            stocktransfer :[1,2,3,6],
            department :[1,2,3],
            stocktransferrequest :[1,2,3],
            billofmaterials :[1,2,3],
            recipe :[1,2,3],
            materialconsumption :[1,2,3],
            inventoryTracking :[1,2,3,6],
            materialcreation :[1,2,3,5],
            order :[1,2,3,5],
            bill :[1,2,3,5],
            debitnote :[1,2,3,5],
            materialinward :[1,2,3,5],
            BANK_TRANSACTION :[1,2,3],
            payment :[1,2,3,5],
            receipt :[1,2,3,5],
            expense :[1,2,3],
            salesregister :[2],
            report :[2],
            discount :[1,2,3],
            barcodeutility :[1,2,3],
        },
         ACCOUNT_MANAGER_USERROLE_PERMISSIONS  :  {
            suppliers :[2],
            customers :[2],
            employee :[2],
            vendors :[2],
            transport :[2],
            product :[2],
            order :[2],
            bill :[2],
            debitnote :[2],
            materialinward :[2],
            estimate :[2],
            invoice :[2],
            creditnote :[2],
            salesorder :[2],
            mobilepos :[2],
            deliverychallan :[2],
            bank :[1,2,5],
            BANK_TRANSACTION :[1,2],
            payment :[1,2,5],
            receipt :[1,2,5],
            expense :[1,2,3],
            accounts :[1,2,3,4],
            debit_note_accounting :[1,2,3,4,5],
            credit_note_accounting :[1,2,3,4,5],
            JOURNAL_VOUCHER :[1,2,3,4,5],
            salesregister :[2],
            report :[2],
            reportbeta :[2],
        },
        
        SHEET_NAME : {
            0: "A", 1: "B", 2: "C", 3: "D", 4: "E", 5: "F",
            6: "G", 7: "H", 8: "I", 9: "J", 10: "K", 11: "L",
            12: "M", 13: "N", 14: "O", 15: "P", 16: "Q",
            17: "R", 18: "S", 19: "T", 20: "U", 21: "V",
            22: "W", 23: "X", 24: "Y", 25: "Z", 26: "AA",
            27: "AB", 28: "AC", 29: "AD", 30: "AE", 31: "AF",
            32: "AG", 33: "AH", 34: "AI", 35: "AJ", 36: "AK",
            37: "AL", 38: "AM", 39: "AN", 40: "AO", 41: "AP",
            42: "AQ", 43: "AR", 44: "AS", 45: "AT", 46: "AU",
            47: "AV", 48: "AW", 49: "AX", 50: "AY", 51: "AZ",
          },
         USERROLENAME_CASHIER : "Cashier",
         USERROLENAME_PURCHASE_MANAGER : "Purchase Manager",
         USERROLENAME_ACCOUNT_MANAGER : "Account Manager",
         USERROLENAME_DEFAULT_ADMIN : "Default Admin",
        
        
         INDUSTRY_TYPE_FOOD : 1,
         INDUSTRY_TYPE_AGRICULTURE : 2,
        
         POAPPROVAL : "poapproval",
         EXPENSEAPPROVAL : "expenseapproval",
        
         DRAFT : "draft",
         TOAPPROVE : "toapprove",
        
    ////####### JIO TYPES ############# /////
         JIO_TYPE_VASY : 0,
         JIO_TYPE_JPM : 1,
         JIO_TYPE_AJIO : 2,
         JIO_TYPE_AJIO_WHOLESALER : 3,
         JIO_TYPE_FJSK : 4,
         JIO_TYPE_AJIO_DISTRIBUTOR : 5,
        //// ####### JIO TYPES ############# /////
        
        //// ######### MERCHANT TYPE #########////
         MERCHANTTYPE_VASY : 1,
         MERCHANTTYPE_JPM : 2,
         MERCHANTTYPE_AJIO : 3,
         MERCHANTTYPE_AJIO_WHOLESALER : 4,
         MERCHANTTYPE_LCJP : 8,
         MERCHANTTYPE_FW : 9,//Fashion World
        ////######### MERCHANT TYPE #########////
        
         JPM_PUSH_TO_PAY : "jpmPushToPay",
         JPM_COUPONAPI : "jpm_couponapi",
        
         BILLRESTRICTIONANDWARNING : "billRestrictionAndWarning",
         FORUSERTYPE : "forUserType",
         NOOFPREVIOUSBILL : "noOfPreviousBill",
         LASTBILLDUE : "lastBillDue",
        
         ALLOWKOTPRINT : "allowkotprint",
        
         HMAC_ALGORITHM : "HmacSHA256",
         SECRET_KEY : "2743364ce57ee8c273e5194807d5eb4d",
        
         SHOPIFY_ORDER_CANCELLED : "cancelled",
         ALLOWPURCHASEORDERSMS : "allowpurchaseordersms",
        
        // This is for Barcode Setting Master
         BARCODE_SETTING_MASTER : "barcodesettingmaster",
        
        // This is for Print Labels Barcode New Module
         PRINT_LABELS : "printlabels",
        
         CHILD_PARENT_TYPE_ORDER : 1,
         CHILD_PARENT_TYPE_INVOICE : 2,
         CHILD_PARENT_TYPE_DC : 3,
         CHILD_PARENT_TYPE_CREDIT_NOTE : 4,
         HISTORY_TYPE_NEW : "new",
         HISTORY_TYPE_EDITED : "edited",
         HISTORY_TYPE_DELETED : "deleted",
         HISTORY_TYPE_STATUSDEFAULT : "statuschange",
         HISTORY_TYPE_STATUSCHANGE : "statuschange",
         HISTORY_TYPE_CHILDCREATED : "childcreated",
         HISTORY_TYPE_CHILDDELETED : "childdeleted",
        
         HISTORY_TYPE_RECEIPT_NEW : "receiptnew",
         HISTORY_TYPE_RECEIPT_EDIT : "receiptedit",
         HISTORY_TYPE_RECEIPT_DELETE : "receiptdelete",
        
         HISTORY_TYPE_CREDIT_NOTE_NEW : "creditnotenew",
         HISTORY_TYPE_CREDIT_NOTE_DELETE : "creditnotedelete",
         HISTORY_TYPE_CREDIT_NOTE_REDEEM : "creditnoteredeem",
        
         HISTORY_TYPE_SALES_RETURN : "salesreturn",
         HISTORY_TYPE_CASH_RETURN : "cashreturn",
         HISTORY_TYPE_BANK_RETURN : "bankreturn",
        
         HISTORY_TYPE_ORDER_STATUSCHANGE : "orderstatuschange",
         HISTORY_TYPE_PAYMENT_STATUSCHANGE : "paymentstatuschange",
        
         SIGNUPFROMMPOS : "MPOS",
        
        
         ENABLE_ONLINE_ORDER_CONFIRMATION_FLOW : "enableOnlineConfirmationFlow",
         SHOWLANDINGPRICEINPOSPOPUP : "showlandingpriceinpospopup",
        
         IS_ECOMMERCE_MERCHANT: "isEcommerceMerchant",
         OTP_EXPIRE_SECONDS : "300",
        
         ALLOW_TALLY_EXPORT: "isTallyExport",
        
         SHOPIFYCREATENEWVARIANT : "/variants",
        
         POSTPAID : "postpaid",
         MONTHLY : "monthly",
        
         SHOPIFYPRODUCTCREATE : "productcreatewebhook",
         SHOPIFYPRODUCTUPDATE : "productupdatewebhook",
         SHOPIFYORDERCREATE : "ordercreatewebhook",
         SHOPIFYORDERUPDATE : "orderupdatewebhook",
         SHOPIFYORDERCANCEL : "ordercancelwebhook",
         SHOPIFYPRODUCTDELETE : "productdeletewebhook",
        
         JIOSIGNUFORM : "JIOENTERPRISE",
        
        ////####### CHANNEL MASTER TYPES ############# /////
        
         CHANNEL_TYPE_VASYECOMMERCE : "vasyEcommerce",
         CHANNEL_TYPE_WOOCOMMERCE : "wooCommerceOrder",
         CHANNEL_TYPE_SHOPIFY : "shopifyOrder",
         CHANNEL_TYPE_MPOS : "MPOS",
         CHANNEL_TYPE_POS : "POS",
         CHANNEL_TYPE_REACTPOS : "REACTPOS",
         CHANNEL_TYPE_ONDC : "ONDC",
         CHANNEL_TYPE_VORDER : "VORDER",
        //// ####### CHANNEL MASTER TYPES ############# /////
         ANY_ECOMMERCE_ACTIVE : "anyecommerceactive",
         NOTIFICATIONONLINEORDERS : "notificationonlineorders",
         VCONNECT_SECRET_KEY : "Croods@205",
         PAID : "paid",
        
         UPDATESHOPIFYPRICEFROMSHUPPLIERBILL : "updateshopifypricefromsupplierbill",
         UPDATEWOOCOMMERCEPRICEFROMSHUPPLIERBILL : "updatewooCommercepricefromsupplierbill",
         UNREGISTERED : "UnRegistered",
        
         COMPANY : "company",
         BRANCH : "branch",
         TAXCODE_GST0 : "gst0",
         TAXCODE_EXCEMPT : "exempt",
         TAXCODE_NONGST : "non_gst",
        
        ////####### SMS SETTING TYPES ############# /////
         SMS_SETTING_TYPE_SMS : "sms",
         SMS_SETTING_TYPE_WHATSAPP : "whatsapp",
         MESSAGE_TEMPLATE_TYPE_SMS : "sms",
         MESSAGE_TEMPLATE_TYPE_WHATSAPP : "whatsapp",
        
        ////####### SMS SETTING TYPES ############# /////
        
        //####### ENABLE WISHLIST FOR ECOMMERCE ############# /////
         ENABLE_WISHLIST : "enableWishlist",
        //####### ENABLE WISHLIST FOR ECOMMERCE ############# /////
        
    
         ALLOWFEEDBACK : "allowfeedback",
         FEEDBACK : "feedback",
        
         OTP_SEND_LIMIT_TYPE_FEEDBACK : "feedback",
    
        
         BELL_NOTIFICATION : 8,
        
        // NOTIFICATION TYPES
         NOTIFICATION_BIRTHDAY : "Birthday",
         NOTIFICATION_ANNIVERSARY : "Anniversary",
         NOTIFICATION_PAYABLE : "Payable",
         NOTIFICATION_RECEIVABLE : "Receivable",
         NOTIFICATION_ORDERS : "Orders",
         NOTIFICATION_STOCK_ALERT : "Stock Alert",
         NOTIFICATION_OTHERS : "Others",
         NOTIFICATION_INVENTORY : "Inventory",
        
        //######## PAYMENT STATUS ############
         PAYMENT_STATUS_PAID : "Paid",
         PAYMENT_STATUS_DUE : "Due",
         PAYMENT_STATUS_OVERDUE : "Overdue",
         PAYMENT_STATUS_PARTIAL_REFUND : "Partial Refund",
         PAYMENT_STATUS_REFUND : "Refunded",
         PAYMENT_STATUS_CREDIT_NOTE_GENERATED : "Credit Note Generated",
        //######## PAYMENT STATUS ############
        
         POS_RETURN_TYPE_CASH_RETURN: "Cash Return",
         POS_RETURN_TYPE_SALES_RETURN: "Sales Return",
        
         ENABLE_CUSTOMER_FACING_DISPLAY : "enableCustomerFacingDisplay",
        
         CONTENT_TYPE_CSV : "application/csv",
         CONTENT_TYPE_EXCEL : "application/octet-stream",
        
        
        // INTERAKT : CONSTANT
         INTERAKT_TRACK_USER_URL : "/v1/public/track/users/",
         INTERAKT_SEND_MESSAGE_URL : "/v1/public/message/",
        // INTERAKT : CONSTANT
        
        // Resubmit order
             AJIO_RESUBMITORDER : "ajio_resubmitorder",
             JPM_RESUBMITORDER : "jpm_resubmitorder",
            
             AJIO : "ajio",
             AJIO_WHOLESALER : "ajiowholesaler",
             AJIO_DISTRIBUTOR : "ajiodistributor",
            
         FLATDISCOUNTLIMIT : "flatdiscountlimit",
         SALESFLATDISCOUNTLIMIT : "salesflatdiscountlimit",
         AJIOWHOLSELLERDISCOUNTLIMIT : "ajiowholsellerdiscountlimit",
        
    //	Default tax setting constant
         DEFAULT_TAX : "defaulttax",
         PUBLISH : "PUBLISH",
         AJOICASHDISCOUNT:"AJOICASHDISCOUNT",
         AJIOWHOLSELLERCASHDISCOUNT:"ajiowholsellercashdiscount",
         AJIOWHOLESALERSHIPMENT_RECORD_LIMIT:"ajiowholsellershipmentrecordlimit",
        
         DB_REPLICA : "replica",
         DB_PRIMARY : "primary",
        
         SSE_KOT_ORDER_COMPLATE : "kot_ordercomplate",
         SSE_KOT_POS_GENRATEBILL : "kot_posgenratebill",
         SSE_KOT_POS_TABLE : "kot_postable",
         SSE_KOT_LIST : "kot_list",
         SSE_KOT_TABLE_FREE : "kot_tablefree",
         SSE_CONNECT : "SSE_CONNECT",
         FJSKMERCHANTDAILYEMAIL : "fjskmerchantdailyemail",
        
        
         BULKPRICEUPDATE : "bulkpriceupdate",
        
        // Typesense constant
         ALLOWTYPESENSE : "allowTypesense",
         TYPESENSECOLLECTIONCREATED : "typesenseCollectionCreated",
         COLLECTIONFORTYPESENSE : "/collections",
         TYPESENSECREATESINGLEDOCUMENT : "/documents",
         TYPESENSECREATEBULKDOCUMENT : "/documents/import",
    
         FJSKMERCHANTMID : "jpmfjskmerchantmid",
         INTERNAL_LOGIN_PORTAL : "internalloginportal",
         PRINT_DATE_FORMAT : "printdateformat",
    
         STOPUMOWISEDECIMAL : "stopumowisedecimal",
         USER_ACTIVITY_LOG_MODULE_STOCK_RESET : "STOCK RESET",
         USER_ACTIVITY_LOG_MODULE_ACCOUNT_RESET : "ACCOUNT RESET",
        
         REDIS_STREAM : "SSEEVENT",
         REDIS_STREAM_DATA : "SSEEVENTDATA",
        
         SHOPIFY_PAYMENT_STATUS_PENDING :	"pending",
         SHOPIFY_PAYMENT_STATUS_AUTHORIZED : "authorized",
         SHOPIFY_PAYMENT_STATUS_OVERDUE : "overdue",
         SHOPIFY_PAYMENT_STATUS_EXPIRED : "expired",
         SHOPIFY_PAYMENT_STATUS_PAID : "paid",
         SHOPIFY_PAYMENT_STATUS_REFUNDED : "refunded",
         SHOPIFY_PAYMENT_STATUS_PARTIALLY_REFUNDED : "partially_refunded",
         SHOPIFY_PAYMENT_STATUS_PARTIALLY_PAID : "partially_paid",
         SHOPIFY_PAYMENT_STATUS_VOIDED : "voided",
         SHOPIFY_PAYMENT_STATUS_UNPAID : "unpaid",
         SHOPIFY_PAYMENT_STATUS_ANY : "any",
        
         WOO_PAYMENT_STATUS_PENDING_PAYMENT : "pending",
         WOO_PAYMENT_STATUS_FAILED : "failed",
         WOO_PAYMENT_STATUS_PROCESSING : "processing",
         WOO_PAYMENT_STATUS_COMPLETED : "completed",
         WOO_PAYMENT_STATUS_ON_HOLD : "on-hold",
         WOO_PAYMENT_STATUS_CANCELLED : "cancelled",
         WOO_PAYMENT_STATUS_REFUNDED : "refunded",
         WOO_PAYMENT_STATUS_TRASH : "trash",
        
         AJIO_INVENTORY_SHIPMENT : "ajioinventoryshipment",
         AJIOWHOLESALER_INVENTORY_SHIPMENT : "ajiowholesalerinventoryshipment",
         AJIOWHOLESALER_SAPINVENTORYSYNC : "ajiowholesalersapinventorysync",
         AJIOWHOLESALER_REPORT_TYPE_SALES : "Merchantwise Sales Report",
         AJIOWHOLESALER_DAILYEMAIL : "ajiowholesalerdailyemail",
         AJIOWHOLESALER_FILE_REJECTION_HISTORY : 5,
            
         Sales_Tax : "taxIncluded",
         Purchase_Tax : "purchaseTaxIncluded",
         Taxdefault : "taxdefault",
        
         SSE_VISHWAMAPI : "vishwamapi",
         V1SETTRANSACTIONSTATUS  : "/v1/set_ika_transaction_status",
         V1ADDBILLONFO  : "/v1/add_ika_bill_info",
         V1NEWLYPRODUCTADD  : "/v1/get_newly_added_product",
         VISHWAM : "vishwam",
    
         NOTIFICATION_THREAD_PREFIX : "noti-exe-",
         POS_THREAD_PREFIX : "pos-exe-",
         CASHDISCOUNTLIMIT : "cashdiscountlimit",
    
         OWNERNUMBER : "ownerNumber",
         APPLICATION_NAME : "ProductImageSearch",
         SALESREGISTER : "salesregister",
         REPORT_TYPE_SALESANDSALESRETURN : "Sales and Sales Return Item Register",
         REPORT_TYPE_STOCKTRANSFERITEM : "Stock Transfer Item Wise Summary",
        
        //######## SETTINGS :> INTEGRATION :> URL CONSTANTS :: START ########
        
         SETTINGS_INTEGRATION_ECOMMERCE_WOOCOMMERCE : "woocommerce",
         SETTINGS_INTEGRATION_ECOMMERCE_SHOPIFY : "shopify",
         SETTINGS_INTEGRATION_ECOMMERCE_VCOMMERCE : "vcommerce",
        
         SETTINGS_INTEGRATION_PAYMENT_CASHFREE : "cashfree",
         SETTINGS_INTEGRATION_PAYMENT_RAZORPAY : "razorpay",
         SETTINGS_INTEGRATION_PAYMENT_PAYTM : "paytm",
         SETTINGS_INTEGRATION_PAYMENT_INSTAMOJO : "instamojo",
         SETTINGS_INTEGRATION_PAYMENT_PINELABS : "pinelabs",
         SETTINGS_INTEGRATION_PAYMENT_EZEYTAP : "ezeytap",
         SETTINGS_INTEGRATION_PAYMENT_MSWIPE : "mswipe",
        
         SETTINGS_INTEGRATION_MESSAGE_MSG91 : "msg91",
         SETTINGS_INTEGRATION_MESSAGE_TEXT_LOCAL : "textlocal",
         SETTINGS_INTEGRATION_MESSAGE_TWILLO : "twillo",
         SETTINGS_INTEGRATION_MESSAGE_SMS_JUST : "smsjust",
         SETTINGS_INTEGRATION_MESSAGE_INTERAKT : "interakt",
         SETTINGS_INTEGRATION_MESSAGE_VASY_WHATSAPP : "vasywhatsapp",
        
         SETTINGS_INTEGRATION_LOYALTY_REELO : "reelo",
         SETTINGS_INTEGRATION_LOYALTY_VASYERP : "vasyloyalty",
        
         SETTINGS_INTEGRATION_GST_EINVOICE : "einvoice",
         SETTINGS_INTEGRATION_GST_EWAYBILL : "ewaybill",
        
         SETTINGS_INTEGRATION_CFD_LOGO : "cfdlogo",
         SETTINGS_INTEGRATION_CFD_BANNER : "cfdbanner",
            
        //######## SETTINGS :> INTEGRATION :> URL CONSTANTS :: ENDS  ########
    
        //Shopify payment methods constant
         CASH_ON_DELIVERY : "Cash on Delivery (COD)",
         CASH_FREE : "cashfree",
         INSTAMOJO : "instamojo",
         COP : "cop",
         RAZORPAY : "razorpay",
         NOT_DEFINED : "not defined",
        //Shopify payment methods constant end
    
         COMPANYID : "companyId",
         USERID : "userId",
         MATERIALCONSUMPTIONTYPE : "materialconsumptiontype",
    
         EMAIL_CUSTOMER_SERVICE :"VasyERP" ,
         COUNTRY_CODE_IN : "IN",
         DELIVERY_CHARGE : "delivery charge",
         POS_CUSTOMER : "POS customer",
         LOANS_AND_LIABILITIES : "Loans & Liabilities",
    
         WHOLESALE : "wholesale",
    }

    export default Constant;